import {ActionContext} from "vuex";
import {State as RootState} from "@/store";
import {EmailRecord, EmailRecordState} from "@/store/EmailRecord/EmailRecordState";
import {getStoreAccessors} from "vuex-typescript";

type EmailRecordContext = ActionContext<EmailRecordState, RootState>;

export const emailRecord = {
    namespaced: true,

    state: {
        SearchResult: []
    },

    getters: {
        getSearchResults(state: EmailRecordState):any {
            return state.SearchResult;
        },
    },

    mutations: {
        mutateSearchResult: function (state: EmailRecordState, searchResult: EmailRecord[]) {
            if (state.SearchResult !=null && state.SearchResult.length >0){
                state.SearchResult.length = 0;
            }
            else{
                state.SearchResult = new Array();
            }
            state.SearchResult = searchResult;
        }
    },

    actions: {
        updateSearchResult: function (context: EmailRecordContext, searchResult: EmailRecord[]) {
            commitSearchResult(context, searchResult)
        }
    },
};
const { commit, read, dispatch } =
    getStoreAccessors<EmailRecordState, RootState>("emailRecord");

const getters:any = emailRecord.getters;
export const getSearchResult:any = read(getters.getSearchResults);

const actions: any = emailRecord.actions;
export const updateSearchResult:any =dispatch(actions.updateSearchResult)

const mutations:any = emailRecord.mutations;
export const commitSearchResult:any = commit(mutations.mutateSearchResult);
